
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Activity, Cell, Duty } from '../backend/backendapi';
import TodoList from '../todolist/TodoList';
import { getCheckListJson } from './util';

@Component({
  components: {
    TodoList,
  },
})
export default class TabTasks extends Vue {
  @Prop({ required: true })
  readonly duty!: Duty;
  @Prop({ required: true })
  readonly activity!: Activity;
  @Prop({ required: true })
  readonly cells!: Cell[];
  @Prop({ required: true })
  readonly disabled!: boolean;

  get todoJson(): string {
    return getCheckListJson(this.activity, this.duty);
  }

  todoListChanged(strJson: string): void {
    this.activity.jsonVMChecklist = strJson;
  }
}
